import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

const Ratio3: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <rect
        width="2"
        height="8"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 16 4)"
        fillOpacity="0.87"
      />
      <rect
        width="2"
        height="8"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 16 22)"
        fillOpacity="0.87"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 16L19 8L5 8L5 16L19 16ZM21 6L3 6L3 18L21 18L21 6Z"
        fillOpacity="0.87"
      />
    </SvgIcon>
  );
};

export default Ratio3;
